import React, { useState, useEffect } from 'react';
import { Row, Col, FormGroup, Card } from 'react-bootstrap';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { isEmpty, cloneDeep } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import CustomDetails from './fromFormComponents/CustomDetails';
import * as action from '../store/POTemplate.action';
import { ElementTemplate } from '../TemplateComponent';
import { usePOTemplateState } from '../P.O.TemplateContext/index';

function CustomSection({ element, fromForm, eleIndex, itemDragging }) {
  const [customData, setCustomData] = useState(null);
  const [forEditData, setForEcitData] = useState(null);
  const { duplicatingItem, deleteItem, editingInput, changeLabel, dropLocation, dropInLocation, deleteCard, modfiyReqAndEnable, poState, inSave, setPOState } =
    usePOTemplateState();

  const dispatch = useDispatch();
  const {
    poTemplateData: { custData },
  } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    if (!isEmpty(element)) {
      setCustomData({ ...element });
    }
  }, [element]);

  useEffect(() => {
    if (!isEmpty(customData)) {
      const updatedData = cloneDeep(customData);
      updatedData.columns = customData?.columns?.map((arrEle) => {
        return arrEle.filter((e) => e?.id);
      });
      setForEcitData(updatedData);
    }
  }, [customData]);

  const changePosition = (item, index, i, eleIndex) => {
    if (eleIndex !== item?.eleIndex) {
      const dragedItem = item?.col;
      const newColumns = customData?.columns;
      const rightSide = poState?.rigthColumn;
      const oldColumns = rightSide?.templateJsonSchema[item?.eleIndex]?.columns;
      newColumns[index].splice(i, 0, dragedItem);
      oldColumns[item?.index].splice(item?.i, 1);
      setPOState((oldData) => ({ ...oldData, rigthColumn: rightSide }));
      setCustomData((previousData) => ({
        ...previousData,
        columns: newColumns,
      }));
    } else {
      const dragedItem = item?.col;
      const newColumns = customData?.columns;
      newColumns[index].splice(i, 0, dragedItem);
      if (newColumns[item?.index][item?.i]?.id === newColumns[index][i]?.id) {
        newColumns[item?.index].splice(item?.i, 1); // very Important to be after new item is added
      } else {
        newColumns[item?.index].splice(item?.i + 1, 1);
      }
      setCustomData((previousData) => ({
        ...previousData,
        columns: newColumns,
      }));
    }
  };

  useEffect(() => {
    if (
      inSave &&
      customData &&
      custData?.length !== poState?.rigthColumn?.templateJsonSchema?.filter((e) => e?.key === 'Section' || e?.key === 'Terms_conditions')?.length
    ) {
      dispatch(action.customUpdate(customData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inSave, customData, dispatch, custData]);

  const onChangeCustom = (value, label, i, eleIndex, index) => {
    const template = [...(customData?.columns || [])];
    if (template[index][i].key !== 'Dropdown' && template[index][i].options) {
      const updatedOptions = template[index][i].options.map((e) => {
        if (e.name === label) {
          return { ...e, value };
        }
        return e;
      });
      template[index][i].options = updatedOptions;
    } else {
      template[index][i].value = value;
    }
    setCustomData((previosState) => ({
      ...previosState,
      columns: template,
    }));
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Card className="listing-card">
        <Card.Header className={`px-2 py-2 bgcolor-dark ${fromForm && 'd-flex'}`}>
          <strong onClick={() => changeLabel(customData, eleIndex)}>{customData?.label?.length > 0 ? customData?.label : '-'}</strong>
          {fromForm && itemDragging?.type !== 'container' && (
            <>
              <button
                className="btn btn-border ml-auto "
                type="button"
                name="edit"
                key={`${element?.key}_${eleIndex}_edit`}
                onClick={() => {
                  modfiyReqAndEnable(forEditData, eleIndex);
                }}
              >
                <span className="icon-edit" />
              </button>
              <button className="btn btn-border " type="button" name="delete" key={`${element?.key}_${eleIndex}_delete`} onClick={() => deleteCard(eleIndex)}>
                <span className="icon-delete" />
              </button>
            </>
          )}
        </Card.Header>
        {itemDragging?.type !== 'container' && (
          <Card.Body>
            <Row className="py-3">
              {customData?.columns?.map((colEle, index) => {
                return (
                  <Col lg={6} key={index}>
                    {colEle?.map((ele, i) => {
                      return (
                        <FormGroup key={i}>
                          {fromForm ? (
                            <CustomDetails
                              col={ele}
                              index={index}
                              i={i}
                              dropLocation={dropLocation}
                              changePosition={changePosition}
                              dropInLocation={dropInLocation}
                              fromForm={fromForm}
                              duplicatingItem={duplicatingItem}
                              editingInput={editingInput}
                              eleIndex={eleIndex}
                              customData={customData}
                              onChange={onChangeCustom}
                              deleteItem={deleteItem}
                              elementId={element?.id}
                              fromCustomSection
                            />
                          ) : (
                            <ElementTemplate
                              {...ele}
                              keys={ele?.key}
                              error={ele?.hasError}
                              requiredField={ele?.required}
                              disable
                              value={ele?.value}
                              options={ele?.options}
                              placeHolder={ele?.placeholder ? `${ele?.placeholder}` : `${ele?.label}`}
                              fromForm={fromForm}
                              elementId={element?.id}
                              fromCustomSection
                            />
                          )}
                        </FormGroup>
                      );
                    })}
                  </Col>
                );
              })}
            </Row>
          </Card.Body>
        )}
      </Card>
    </DndProvider>
  );
}

export default CustomSection;
